$(document).ready(function() {
	let timerList = {};

	let runCounter = function ($item) {
		clearTimeout(timerList[$item.data('index')]);
		$item.html(0);
		$item.parent().removeClass('animate__animated animate__rubberBand');
		let time = 3000;
		let delay = Math.ceil(time / $item.data('max-value'));
		let number = 0;

		if (delay < 50) {
			delay = 50;
		}
		if (delay > 100) {
			delay = 100;
		}

		let step = Math.ceil($item.data('max-value') / (time / delay));

		timerList[$item.data('index')] = setInterval(function() {
			number += step;

			if (number >= $item.data('max-value')) {
				clearTimeout(timerList[$item.data('index')]);
				$item.html($item.data('max-value'));
				$item.parent().addClass('animate__animated animate__rubberBand');
				return;
			}

			$item.html(number);
		}, delay);
	};

	if (typeof MutationObserver === 'function') {
		let observer = new MutationObserver(function (mutationList, observer) {
			$.each(mutationList, function (index, value) {
				let $item = $(value.target);
				if (value.target.classList.contains($item.data('animation'))) {
					runCounter($item);
				}
				else {
					clearTimeout(timerList[$item.data('index')]);
				}
			});
		});

		let iterator = 1;
		$('#counter [data-max-value]').each(function () {
			$(this).data('index', iterator);
			timerList[iterator] = undefined;
			iterator += 1;

			observer.observe(this, {
				attributes: true
			});
		});
	}
});
